// @ts-nocheck
import { PrescriptionType } from 'shared/consts/prescription'
import { PRESCRIPTION_TYPE_NO_PRESCRIPTION } from 'shared/consts/productTemplates'
import store from 'shared/store'
import { updatePrescriptionType } from 'shared/store/ducks/events'
import Storage from 'views/assets/scripts/services/storage/storage'

const CHOICES_INSTANCE_SELECTOR = '[name="prescriptionType"]'
const PRODUCT_VARIANT_LINK_SELECTOR =
  '[data-clientside-hook~="productVariant__link"]'

const storage = new Storage('sessionStorage')

export const handleVariantClick = (prescriptionType: PrescriptionType) => {
  if (!storage.isAvailable()) {
    return null
  }

  const variantLinks = [
    ...document.querySelectorAll<HTMLElement>(PRODUCT_VARIANT_LINK_SELECTOR),
  ]

  return variantLinks.map(variantLink => {
    const id = variantLink.dataset.productVariantId || null

    const onClick = () => {
      if (prescriptionType !== PRESCRIPTION_TYPE_NO_PRESCRIPTION) {
        storage.set(id, prescriptionType)
      }
    }

    variantLink.addEventListener('click', onClick)

    return variantLink
  })
}

export default () => {
  if (!storage.isAvailable()) {
    return null
  }

  const {
    // @ts-ignore
    ProductVariantsInitialState: { currentVariantId },
  } = store.getComponentInitialState()

  const prescriptionSelects = document.querySelectorAll<HTMLSelectElement>(
    CHOICES_INSTANCE_SELECTOR
  )

  if (prescriptionSelects.length > 0) {
    const prescriptionType = storage.get(currentVariantId)

    if (prescriptionType) {
      prescriptionSelects.forEach(select =>
        store.dispatch(
          updatePrescriptionType({ select, value: prescriptionType })
        )
      )

      prescriptionSelects[0].dispatchEvent(
        new CustomEvent('change', prescriptionSelects[0])
        // FIXME for the code owner, use `detail` prop?
        // new CustomEvent('change', { detail: prescriptionSelects[0] })
      )

      storage.clear()
    }

    const handlePrescriptionTypeChange = (event: Event) => {
      const target = <HTMLInputElement>event.target

      prescriptionSelects.forEach(select => {
        if (!select.isEqualNode(target)) {
          store.dispatch(
            updatePrescriptionType({ select, value: target.value })
          )
        }
      })
    }

    prescriptionSelects.forEach(select => {
      select.addEventListener('change', handlePrescriptionTypeChange)
    })

    return handleVariantClick(prescriptionSelects[0].value)
  }

  return null
}
